/**
 * DR Gifts Email Eligibility
 *
 * Validates DRNEW eligibility via App Proxy and applies coupon if eligible.
 */
(function() {
  'use strict';

  if (window.__drGiftsEmailEligibilityMounted) return;
  window.__drGiftsEmailEligibilityMounted = true;

  const DEBUG = new URLSearchParams(location.search).has('drGiftsEmailDebug');

  function debugLog(...args) {
    if (DEBUG) console.log('[DR Gifts Email]', ...args);
  }

  function getConfig() {
    const cfg = window.DR_GIFTS_EMAIL;
    if (!cfg) return null;
    return {
      code: String(cfg.code || 'DRNEW').trim().toUpperCase(),
      endpoint: String(cfg.endpoint || '/apps/drnew/eligibility').trim(),
      successText: String(cfg.successText || '✅ קיבלת הנחה נוספת של 5% (DRNEW)'),
      usedText: String(cfg.usedText || 'כבר השתמשת בהטבה'),
      invalidText: String(cfg.invalidText || 'נא להזין כתובת אימייל תקינה'),
      errorText: String(cfg.errorText || 'משהו השתבש, נסה שוב')
    };
  }

  function getDrawer() {
    return document.querySelector('cart-drawer#mini-cart') ||
           document.querySelector('cart-drawer') ||
           document.querySelector('#mini-cart');
  }

  function getWidget(drawer) {
    if (!drawer) drawer = getDrawer();
    if (!drawer) return null;
    return drawer.querySelector('[data-dr-email]');
  }

  function getElements(widget) {
    return {
      form: widget?.querySelector('[data-dr-email-form]'),
      input: widget?.querySelector('[data-dr-email-input]'),
      submit: widget?.querySelector('[data-dr-email-submit]'),
      error: widget?.querySelector('[data-dr-email-error]'),
      details: widget,
      success: document.querySelector('[data-dr-email-success]'),
      successText: document.querySelector('[data-dr-email-success-text]')
    };
  }

  function setLoading(state, els) {
    if (!els) return;
    if (els.submit) {
      els.submit.disabled = state;
      if (state) {
        els.submit.setAttribute('aria-busy', 'true');
      } else {
        els.submit.removeAttribute('aria-busy');
      }
    }
    if (els.input) {
      els.input.disabled = state;
    }
  }

  function showResult(text, els, tone) {
    if (!els) return;

    if (tone === 'error' || tone === 'used') {
      if (els.error) {
        els.error.textContent = text;
        els.error.classList.toggle('is-used', tone === 'used');
        els.error.removeAttribute('hidden');
      }
      return;
    }

    if (els.details) {
      els.details.setAttribute('hidden', '');
    }
    if (els.success && els.successText) {
      els.successText.textContent = text;
      els.success.removeAttribute('hidden');
    }
  }

  async function applyDiscount(code) {
    if (!window.drGiftsReconciler?.applyDiscountCode) {
      throw new Error('reconciler_missing');
    }
    const result = await window.drGiftsReconciler.applyDiscountCode(code, { mode: 'append' });
    if (!result?.success) {
      throw new Error('apply_failed');
    }
  }

  async function handleSubmit() {
    const config = getConfig();
    const widget = getWidget();
    const els = getElements(widget);
    if (!config || !widget || !els.input || !els.submit || !els.form) return;

    const email = String(els.input.value || '').trim().toLowerCase();
    if (!email) {
      els.input.focus();
      return;
    }

    if (els.input && !els.input.checkValidity()) {
      els.input.setCustomValidity(config.invalidText);
      els.input.reportValidity();
      return;
    }

    setLoading(true, els);

    try {
      const response = await fetch(config.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ email })
      });

      if (!response.ok) {
        throw new Error(`eligibility_http_${response.status}`);
      }

      const data = await response.json();
      if (data?.eligible) {
        await applyDiscount(config.code);
        showResult(config.successText, els, 'success');
        debugLog('Eligible, code applied');
        return;
      }

      if (data?.alreadyUsed) {
        showResult(config.usedText, els, 'used');
        debugLog('Ineligible: already used');
        return;
      }

      showResult(config.usedText, els, 'used');
      debugLog('Ineligible: has orders');
    } catch (err) {
      console.error('[DR Gifts Email] Error:', err);
      showResult(config.errorText, els, 'error');
    } finally {
      setLoading(false, els);
    }
  }

  function setupListeners() {
    const config = getConfig();

    document.addEventListener('click', (e) => {
      const widget = getWidget();
      if (!widget) return;

      if (e.target.closest('[data-dr-email-submit]')) {
        e.preventDefault();
        e.stopPropagation();
        handleSubmit();
        return;
      }
    }, true);

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      if (e.target.matches('[data-dr-email-input]')) {
        e.preventDefault();
        e.stopPropagation();
        handleSubmit();
      }
    }, true);

    document.addEventListener('input', (e) => {
      if (e.target.matches('[data-dr-email-input]')) {
        e.target.setCustomValidity('');
      }
    }, true);

    document.addEventListener('invalid', (e) => {
      if (e.target.matches('[data-dr-email-input]')) {
        if (config) {
          e.target.setCustomValidity(config.invalidText);
        }
      }
    }, true);

    document.addEventListener('pointerdown', (e) => {
      if (e.target.closest('[data-dr-email]')) {
        e.stopPropagation();
      }
    }, true);
  }

  function init() {
    const config = getConfig();
    if (!config) return;
    debugLog('Init', config);
    setupListeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
